import "./LegalPage.css";

export default function LegalPage({ eyebrow, title, intro, sections, lastUpdated }) {
  return (
    <section className="legal-page">
      <div className="legal-page__hero">
        <p className="legal-page__eyebrow">{eyebrow}</p>
        <h1 className="legal-page__title">{title}</h1>
        <p className="legal-page__intro">{intro}</p>
        <p className="legal-page__meta">Last updated {lastUpdated}</p>
      </div>

      <div className="legal-page__card">
        {sections.map((section) => (
          <article key={section.heading} className="legal-page__section">
            <h2>{section.heading}</h2>
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.items?.length ? (
              <ul>
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
          </article>
        ))}
      </div>
    </section>
  );
}



